import api from '../../api/nodeBackApi';

export const getUsersByCustomerId = async (customerId) => {
  try {
    const response = await api.get(`/api/users/getUsersByCustomerId/${customerId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching users by customer id:', error);
    throw error;
  }
};

//users/create
export const createUser = async (userData) => {
  try {
    const response = await api.post(`/api/users/create`, userData);
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

    ///update/:id
export const updateUser = async (id, userData) => {
  try {
    const response = await api.put(`/api/users/update/${id}`, userData);
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

//delete/:id
  export const deleteUser = async (id, userRole) => {
    console.log("roleHere:", userRole);
    try {
      const response = await api.delete(`/api/users/delete/${id}`,
        {
            data: { 
                role: userRole 
            }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error;
    }
  };

  export const changePwd = async (id, newPassword) => {
    try {
      const response = await api.post(`/api/users/updatePasswordFromLanding/${id}`, { newPassword });
      return response.data;
    } catch (error) {
      console.error('Error changing password:', error);
      throw error;
    }
  };
